// extracted by css-extract-rspack-plugin
export default {"JoinCell":"JoinDraft-module__JoinCell___K1pCC","JoinConditionCell":"JoinDraft-module__JoinConditionCell___me1m3"};